/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgIncreaseIndentRtl = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 7H2V5h20zm-1.707 1.293 1.414 1.414L19.414 12l2.293 2.293-1.414 1.414L16.586 12zM15 11H2V9h13zm0 4H2v-2h13zm7 4H2v-2h20z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgIncreaseIndentRtl as IncreaseIndentRtl };
